import { FormattedMessage } from "react-intl";
import LoginTemplate from "components/templates/LoginTemplate";
import LoginForm from "components/forms/LoginForm";
import LoginWrapper from "components/layout/LoginWrapper";
import VerificationForm from "components/forms/VerificationForm";
import Typography from "components/common/Typography";
import { Form } from "antd";

import { useLoginForm } from "./hooks";

const Login = () => {
  const {
    loading,
    onFinish,
    form,
    step,
    resendCode,
    secondsUntilNextloginAttempt,
  } = useLoginForm();
  const formList = [
    <LoginForm {...{ loading }} />,
    <VerificationForm
      {...{ loading, resendCode, secondsUntilNextloginAttempt }}
    />,
  ];

  return (
    <LoginTemplate>
      <Typography.Paragraph size="l" align="center">
        <FormattedMessage defaultMessage="Login" />
      </Typography.Paragraph>
      <LoginWrapper>
        <Form
          name="loginForm"
          layout="vertical"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          initialValues={{ pinCode: "", phoneNumber: "" }}
          autoComplete="off"
          disabled={loading}
          validateTrigger="onSubmit"
          {...{ onFinish, form }}
        >
          {formList[step]}
        </Form>
      </LoginWrapper>
    </LoginTemplate>
  );
};

export default Login;
